import {Component, Input, ViewChild} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  FormControlDirective,
  NG_VALUE_ACCESSOR, Validators
} from "@angular/forms";
import {AbstractComponent} from "../abstract.component";
import {generateFormId} from "@utility";

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: CheckboxComponent,
            multi: true
        }],
    standalone: false
})
export class CheckboxComponent extends AbstractComponent implements ControlValueAccessor, Validators {
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() cssClass?: string;
  @Input() hideErrorMessage?: boolean;
  formId?: string;

  constructor(private controlContainer: ControlContainer) {
    super();
  }

  ngOnInit() {
    this.formId = generateFormId(this.formControlName);
  }

  @ViewChild(FormControlDirective, {static: true}) formControlDirective?: FormControlDirective;

  @Input() formControlName?: string;

  // get hold of FormControl instance no matter formControl or formControlName is given.
  // If formControlName is given, then this.controlContainer.control is the parent FormGroup (or FormArray) instance.
  get control(): FormControl {
    return <FormControl<any>>this.controlContainer!.control!.get(this.formControlName!);
  }

  registerOnTouched(fn: any): void {
    this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective?.valueAccessor?.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective?.valueAccessor?.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective?.valueAccessor?.setDisabledState!(isDisabled);
  }
}
